import apiClient from '@u/apiClient'
import UpdateTaskDossierController from '@/wayfinder/actions/App/Http/Controllers/TaskDossier/UpdateTaskDossierController'
import UpdateTaskDossierStatusController from '@/wayfinder/actions/App/Http/Controllers/TaskDossier/UpdateTaskDossierStatusController'
import DeleteTaskDossierController from '@/wayfinder/actions/App/Http/Controllers/TaskDossier/DeleteTaskDossierController'
import BulkDeleteTaskDossierController from '@/wayfinder/actions/App/Http/Controllers/TaskDossier/BulkDeleteTaskDossierController'

// const base_errors = { deceased: {}, events: [] }
const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // #region store

  async storeDossierTask({ commit }, obj) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .post('/api/dossier-task', obj.event)
      .then(async (response) => {
        if (response.status === 201) {
          if (obj.successCallback) {
            obj.successCallback()
          }
        }
      })
      .catch(async (reason) => {
        await commit('setErrors', reason)
      })
  },

  // #endregion

  // #region update

  updateDossierTask: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateTaskDossierController.put({ task_dossier: payload.id }),
          payload.task
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierTaskStatus: ({ commit, state }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateTaskDossierStatusController[
            '/api/task-dossier/update-status/{task_dossier}'
          ].put({ task_dossier: payload.id }),
          {
            new_status: payload.new_status
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // #endregion

  //region delete
  deleteTaskDossierById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteTaskDossierController.delete.delete({
            task_dossier: payload.task_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  /**
   * Deletes the tasks selected on the task dashboard in one request, without undo.
   * @param {object} _context
   * @param {{ ids: string[] }} payload
   * @returns {Promise<{ deleted: number }>} how many tasks were actually deleted
   */
  bulkDeleteTaskDossiers: (_context, payload) =>
    apiClient
      .route(BulkDeleteTaskDossierController.post(), { ids: payload.ids })
      .then((response) => response.data),
  undoDeleteTaskDossierById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteTaskDossierController.undo.get({ id: payload.task_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  //endregion
}
